<!-- repeatable-group.component.html -->
<div *ngIf="rowsForm" [formGroup]="rowsForm">
    @if (isEditable) {
        <app-repeatable-group-toolbar
            [title]="field?.label ?? ''"
            [currentCount]="currentCount"
            [maxRows]="maxRows"
            [addButtonLabel]="field?.input?.repeatableGroupConfiguration?.addButtonLabel ?? 'Agregar'"
            [canAddRow]="canAddRow()"
            [debug]="debug"
            (addRowRequested)="addRow()"
            (debugRequested)="debugDump()">
        </app-repeatable-group-toolbar>
    }

    <div class="repeatable-group" formArrayName="rows" [style.--rg-cols]="visibleSubFields().length">
        <div class="repeatable-header">
            <div class="repeatable-header-cell"></div>

            <ng-container *ngFor="let sf of visibleSubFields(); trackBy: trackBySubFieldKey">
                <div class="repeatable-header-cell">
                    <label class="field-label">{{ sf.label ?? sf.key }}</label>
                </div>
            </ng-container>

            <div class="repeatable-header-cell"></div>
        </div>

        <div
            class="repeatable-row"
            *ngFor="let _row of rowsArray.controls; let rowIndex = index; trackBy: trackByIndex"
            [formGroupName]="rowIndex"
        >
            <div class="repeatable-index repeatable-index-desktop">{{ rowIndex + 1 }}</div>

            <div class="repeatable-row-header repeatable-row-header-mobile">
                <div class="repeatable-index-mobile">{{ rowIndex + 1 }}</div>

                @if (canShowRowActions(rowIndex)) {
                    <app-repeatable-row-actions
                        layout="mobile"
                        [isEditable]="isEditable"
                        [canDeleteRow]="canDeleteRow()"
                        [showProductInfo]="canShowInfoDialog(rowIndex)"
                        (productInfoRequested)="openInfoDialog(rowIndex)"
                        (deleteRequested)="deleteRow(rowIndex)">
                    </app-repeatable-row-actions>
                }
            </div>

            <ng-container *ngFor="let sf of visibleSubFields(); trackBy: trackBySubFieldKey">
                <app-repeatable-cell
                    [sf]="sf"
                    [rowGroup]="getRowGroup(rowIndex)"
                    [rowIndex]="rowIndex"
                    [isEditable]="isEditable"
                    [dropdownOptions]="dropdownOptions(sf, rowIndex)"
                    [onlyText]="onlyTextCellText(sf, rowIndex)"
                    [readOnlyText]="readOnlyCellText(sf, rowIndex)"
                    [numericInputClasses]="getNumericInputClasses(sf, rowIndex)">
                </app-repeatable-cell>
            </ng-container>

            @if (canShowRowActions(rowIndex)) {
                <app-repeatable-row-actions
                    layout="desktop"
                    [isEditable]="isEditable"
                    [canDeleteRow]="canDeleteRow()"
                    [showProductInfo]="canShowInfoDialog(rowIndex)"
                    (productInfoRequested)="openInfoDialog(rowIndex)"
                    (deleteRequested)="deleteRow(rowIndex)">
                </app-repeatable-row-actions>
            }

            @if (shouldShowRowExtra(rowIndex)) {
                <app-repeatable-dose-recommendation [view]="rowExtraView(rowIndex)">
                </app-repeatable-dose-recommendation>
            }
        </div>
    </div>
</div>

<app-repeatable-product-info-dialog
    [visible]="infoDialogVisible"
    [view]="activeInfoDialogView"
    (visibleChange)="onInfoDialogVisibleChange($event)">
</app-repeatable-product-info-dialog>
